// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Mulish_6d9b9d', '__Mulish_Fallback_6d9b9d'","fontStyle":"normal"},"className":"__className_6d9b9d","variable":"__variable_6d9b9d"};